import { render, staticRenderFns } from "./UserNotFoundError.vue?vue&type=template&id=2625bc07&scoped=true"
import script from "./UserNotFoundError.vue?vue&type=script&lang=js"
export * from "./UserNotFoundError.vue?vue&type=script&lang=js"
import style0 from "./UserNotFoundError.vue?vue&type=style&index=0&id=2625bc07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625bc07",
  null
  
)

export default component.exports